import i18n from '@/utils/i18n';
import React, { forwardRef, memo } from 'react';
import {
  CatalogSearchInput,
  CatalogSearchInputProps,
  CatalogSearchInputRef,
} from '@/experiences/sales-portal/components/catalog-search-input';

type OrderEntrySearchInputProps = Omit<CatalogSearchInputProps, 'labels'>;

export type OrderEntrySearchInputRef = CatalogSearchInputRef;

export const OrderEntrySearchInput = memo(
  forwardRef<OrderEntrySearchInputRef, OrderEntrySearchInputProps>(
    (props, ref) => (
      <CatalogSearchInput
        {...props}
        labels={{
          catalogModePlaceholder: i18n.t(
            'sales_portal.order_entry.search_catalog_placeholder',
          ),
          catalogSearchCta: i18n.t(
            'sales_portal.order_entry.search_catalog_cta',
          ),
          clearSearch: i18n.t('clear_search'),
          defaultPlaceholder: i18n.t(
            'sales_portal.order_entry.search_placeholder',
          ),
          keyboardHint: i18n.t(
            'sales_portal.order_entry.search_catalog_keyboard_hint',
          ),
        }}
        ref={ref}
      />
    ),
  ),
);
